import AppDispatcher from 'dispatcher/MgfDispatcher';
import { ActionTypes } from 'constants/MgfConstants';
import history from 'util/history';

class NavigationActions {
  constructor() {
    this._removeHistoryListener = this._createHistoryListener();
  }

  goTo({ pathname, action = 'PUSH' }) {
    if (action === 'PUSH') {
      history.push(pathname);
    } else {
      history.replace(pathname);
    }
  }

  replaceWith({ pathname }) {
    history.replace(pathname);
  }

  goBack() {
    history.goBack();
  }

  _createHistoryListener() {
    return history.listen((e) => this._onLocationChange(e));
  }

  _onLocationChange(location) {
    this._dispatch(ActionTypes.NAVIGATE, {
      currentPlace: location,
    });
  }

  _dispatch(actionType, data = null) {
    AppDispatcher.dispatch({
      actionType,
      data,
    });
  }
}

export default new NavigationActions();
